import { render } from "./CheckboxBlockListOpenableField.vue?vue&type=template&id=0867867d"
import script from "./CheckboxBlockListOpenableField.vue?vue&type=script&lang=js"
export * from "./CheckboxBlockListOpenableField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__